import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, signal, ViewChild} from '@angular/core';
import {CustomerAreaService} from '../../services/consumer-area/customer-area.service';
import {Region} from './angular-bing-maps/region.class';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {debounceTime, first, map, switchMap} from 'rxjs/operators';
import {CustomerArea} from '../../classes/customerarea.class';
import {PushpinService} from '../../services/pushpin/pushpin.service';
import {Settings} from '../../settings.class';
import {Pushpin} from '../../classes/pushpin.class';
import {combineLatest, Observable, of} from 'rxjs';
import {PushpinFilterComponent} from '../pushpin-filter/pushpin-filter.component';
import {MatDialog} from '@angular/material/dialog';
import {CreatePushpinDialogComponent} from '../../pushpin-detail/pushpin-type-selection-dialog/create-pushpin-dialog.component';
import {StatusService} from '../../services/status/status.service';
import {MaterialService} from '../../services/material/material.service';
import {Material} from '../../classes/material.class';
import {DecorationsService} from '../../services/decorations/decorations.service';
import {Decoration} from '../../classes/decoration.class';
import {Status} from '../../classes/status.class';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {CordovaService} from '../../cordova.service';
import {ManualAreasComponent} from './manual-areas/manual-areas.component';
import {ManualArea} from '../../classes/manualarea.class';
import {PushpinFilter} from '../../pushpin-filter';
import {PushpinSelectionComponent} from '../pushpin-selection/pushpin-selection.component';
import {LocalStorage} from '../../storage.class';
import {MatSnackBar} from '@angular/material/snack-bar';
import {LocationService} from '../../pushpin-detail/location-selector-dialog/location.service';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {CodaltComponent} from '../../codalt.component';
import {Inspection} from '../../classes/inspection';
import {PushpinMoveComponent} from '../pushpin-move/pushpin-move.component';
import {AsyncPipe, DatePipe, DecimalPipe, formatNumber} from '@angular/common';
import {GoogleMap, MapAdvancedMarker, MapPolygon, MapPolyline} from '@angular/google-maps';
import {Utils} from '../../utils.class';
import {Hectometre} from '../../hectometre';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatBadge} from "@angular/material/badge";
import {MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {HectoPinIconPipe} from "../../pipes/hecto-pin-icon.pipe";
import {PushpinIconPipe} from "../../pipes/pushpin-icon.pipe";
import {PolylinePathPipe} from "../../pipes/polyline-path.pipe";
import {PolylineColorPipe} from "../../pipes/polyline-color.pipe";
import {MatCheckbox} from "@angular/material/checkbox";
import {LoadingComponent} from "../../loading/loading.component";
import {GoogleMapsLoaderService} from "../../services/google-maps-loader.service";

declare var cordova;

@Component({
    selector: 'app-pushpin-map',
    templateUrl: './pushpin-map.component.html',
    styleUrls: ['./pushpin-map.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        MatBadge,
        MatFormField,
        MatLabel,
        MatAutocomplete,
        ReactiveFormsModule,
        AsyncPipe,
        MatAutocompleteTrigger,
        MatInput,
        MatOption,
        MatIconButton,
        MatIcon,
        RouterLink,
        GoogleMap,
        MapPolygon,
        HectoPinIconPipe,
        PushpinIconPipe,
        PolylinePathPipe,
        MapPolyline,
        PolylineColorPipe,
        DecimalPipe,
        MatCheckbox,
        FormsModule,
        LoadingComponent,
        DatePipe,
        MapAdvancedMarker
    ]
})
export class PushpinMapComponent extends CodaltComponent implements OnInit, AfterViewInit, OnDestroy {

    parser = new DOMParser();

    @Input() nearby: boolean;

    @ViewChild('map', {static: true})
    public googleMap: GoogleMap;
    @Input()
    filterComponent: PushpinFilterComponent;
    @Input()
    selectionComponent: PushpinSelectionComponent;
    @Input()
    manualAreasComponent: ManualAreasComponent;
    @Input()
    pushpinMoveComponent: PushpinMoveComponent;
    @Output()
    pushpinCreated = new EventEmitter<boolean>();
    @Output()
    addExtraCost = new EventEmitter<void>();
    @Output()
    addTailCharge = new EventEmitter<void>();
    @Output()
    chooseInspection = new EventEmitter<void>();
    addressSearch: Observable<any[]> = null;
    addressAutocomplete = new FormControl();
    @Input()
    view = 'map';
    isCordova = false;
    showPriceSelectionBar: boolean;
    readonly pushpins = signal<Pushpin[]>([]);
    readonly mapCenter = signal<{ lat: number; lng: number }>({lat: 0, lng: 0});
    readonly mapZoom = signal<number>(11);
    readonly mapOptions = signal<google.maps.MapOptions>({
        center: {lat: 52.5, lng: 5},
        zoom: 9,
        tilt: 0,
        isFractionalZoomEnabled: false,
        headingInteractionEnabled: false,
        fullscreenControl: false,
        disableDefaultUI: true,
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false,
        restriction: Utils.RestrictToNl(),
        mapId: '6eadd29c953ec0dca61fcbf6'
    });
    readonly mapTypeId = signal<string>('roadmap');
    mapStyleRoad = true;
    lengthMarkDraft?: Pushpin;
    readonly customerArea = signal<CustomerArea>(null);
    readonly inspection = signal<Inspection>(null);
    readonly selectedPushpins = signal<Pushpin[]>([]);
    materials: Material[];
    statuses: Status[];
    decorations: Decoration[];
    selectedPosition: {
        bottom, left, maxHeight, right, top
    };
    showAddPinButton = true;
    isSearching = false;

    lengthMarkUseRoute = false;
    travelModeWalking = false;
    readonly distanceDraftLengthMark = signal<number>(0);
    draftPolyLine: { lat: number; lng: number }[] = [];
    routePoints: { lat: number; lng: number }[] = [];
    showRoutePoints = false;

    gpsLocation: { lat: number; lng: number };
    locationPinIcon = this.parser.parseFromString('<?xml version="1.0" encoding="UTF-8"?>' + `<svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><!-- Generator: Sketch 48.2 (47327) - http://www.bohemiancoding.com/sketch --><title>icons/current</title><desc>Created with Sketch.</desc><defs><path d="M9.99799378,20 C4.48690942,20 0.00200621928,15.5148718 0,10.0035111 C0.00200621928,4.48813763 4.48690942,0.00100315995 10,0 C15.5110844,0 19.9979938,4.48613131 20,10.0005016 C20,15.5138687 15.5130906,20 9.99799378,20" id="path-1"></path><filter x="-30.0%" y="-30.0%" width="160.0%" height="160.0%" filterUnits="objectBoundingBox" id="filter-2"><feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur><feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.4 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix></filter></defs><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="icons/current"><g id="Group-3" transform="translate(6.000000, 6.000000)"><g id="Path"><use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use><use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-1"></use></g><path d="M10,2.00631991 C5.59333935,2.00732307 2.0082255,5.59462306 2.00621928,10.0035111 C2.0082255,14.4083864 5.59133313,17.9936801 9.99799378,17.9936801 C14.4066606,17.9936801 17.9937807,14.4083864 17.9937807,10.0015047 C17.9917745,5.59261674 14.4066606,2.00631991 10,2.00631991" id="Path" fill="#ffdd00"></path></g></g></g></svg>`, 'image/svg+xml').documentElement;
    private gpsWatchId;
    gpsFailure = false;
    followLocation = false;
    hectoPins: Hectometre[];
    public readonly selectionPolygon = signal<Array<{ lat: number, lng: number }>>([]);
    readonly mapsApiLoaded = signal<boolean>(false);

    @ViewChild('searchInput')
    private searchInput: MatInput;
    private prevView: string;
    private townRegion: Region;
    private initialViewAsParam = false;
    private latestUpdatedAt = -1;
    private filter: PushpinFilter;
    private deviceHasInternet = true;
    private areaSnackbarRef;

    constructor(
        private customerAreaService: CustomerAreaService,
        private activatedRoute: ActivatedRoute,
        private activeRoute: ActivatedRoute,
        private pushpinService: PushpinService,
        private router: Router,
        private materialService: MaterialService,
        private decorationsService: DecorationsService,
        private ngZone: NgZone,
        private dialog: MatDialog,
        private confirmDialogService: ConfirmDialogService,
        private statusService: StatusService,
        private matSnackbar: MatSnackBar,
        private locationService: LocationService,
        private cdref: ChangeDetectorRef,
        private cordovaService: CordovaService,
        private googleMapsLoader: GoogleMapsLoaderService
    ) {
        super();
        this.filter = Settings.pushpinFilter;
    }

    coordinatesChange(lat, lng, zoom) {
        if (zoom && !isNaN(+zoom)) {
            this.mapZoom.set(+zoom);
        }
        this.setMapCenter({lat: +lat, lng: +lng});
    }

    back() {
        this.customerAreaService.getList().then(customerAreas => {
            if (customerAreas.length < 2) {
                this.router.navigate(['/']);
            } else {
                this.router.navigate(['/customer-selection']);
            }
        });
    }

    ngOnDestroy(): void {
        navigator.geolocation.clearWatch(this.gpsWatchId);
        this.subscriptions.unsubscribe();
        if (this.areaSnackbarRef) {
            this.areaSnackbarRef.dismiss();
        }
    }

    clearHecto() {
        this.hectoPins = null;
        this.addressAutocomplete.reset();
    }

    openAddressSearch(event) {
        this.isSearching = !this.isSearching;
        if (this.isSearching) {
            setTimeout(() => {
                this.searchInput.value = '';
                this.searchInput.focus();
            }, 100);
        }
    }

    goToAddress(val: MatAutocompleteSelectedEvent) {
        const coords = val.option.value;
        this.setMapCenter({lat: +coords['lat'], lng: +coords['lng']});
        this.mapZoom.set(18);
        this.isSearching = false;
    }

    showAddress(value: any) {
        return value ? value['name'] : '';
    }

    ngAfterViewInit() {
        this.subscriptions.add(
            this.googleMap.mapDragend.pipe(debounceTime(100)).subscribe((event) => {
                this.onCenterChanged();
            })
        );
        this.subscriptions.add(
            this.googleMap.zoomChanged.pipe(debounceTime(100)).subscribe((event) => {
                this.onZoomChanged();
            })
        );
    }

    ngOnInit() {
        this.googleMapsLoader.load().then(() => {
            this.mapsApiLoaded.set(true);
            this.initializeMap();
        }).catch(error => {
            console.error('Failed to load Google Maps', error);
            this.mapsApiLoaded.set(true);
            this.initializeMap();
        });
    }

    public openPushpin(pushpin: Pushpin, pushpinPartId = null) {
        if (this.deviceHasInternet) {
            this.router.navigate([
                'pushpins/map-detail',
                pushpin.id,
                this.mapZoom(),
                this.googleMap.getCenter().lat(),
                this.googleMap.getCenter().lng(),
                {pushpinPartId: pushpinPartId, inspection: this.inspection()?.id}
            ]);
        } else {
            this.confirmDialogService.confirm(
                'Geen Internet',
                'Het apparaat heeft momenteel geen internetverbinding en de punaise kan daarom niet worden geopend.',
                'Oké',
                null).then(() => {

            }, () => {

            });
        }
    }

    setupGeo() {
        if (typeof navigator.geolocation !== 'undefined') {
            if (this.gpsWatchId) {
                navigator.geolocation.clearWatch(this.gpsWatchId);
            }
            this.gpsWatchId = navigator.geolocation.watchPosition((geoData) => {
                    this.gpsFailure = false;
                    this.gpsLocation = {lat: +geoData.coords.latitude, lng: +geoData.coords.longitude};
                    this.cdref.detectChanges();
                    this.routeHistory(geoData);
                    if (this.followLocation) {
                        this.setMapCenter(this.gpsLocation);
                    }
                }, () => {
                    this.gpsFailure = true;
                    if (Utils.isIOS() || Utils.isAndroid()) {
                        this.confirmDialogService.confirm(
                            'GPS locatie niet beschikbaar',
                            'Je hebt ons geen toegang gegeven voor je GPS locatie. ' +
                            'Dit is nodig om de exacte locatie van het probleem vast te stellen.',
                            'Opnieuw proberen', 'Geen GPS gebruiken').then(() => {
                            this.setupGeo();
                        }, () => {
                        });
                    }
                },
                {
                    enableHighAccuracy: true,
                    maximumAge: 3000
                });
        } else {
            setTimeout(() => {
                this.setupGeo();
            }, 3000);
        }
    }

    routeHistory(geoData, justAdd = false) {
        if (this.lengthMarkDraft || justAdd) {
            const snappedPointsHistory = LocalStorage.getSnappedPointsHistory();
            const currentPoint = {lat: +geoData.coords.latitude, lng: +geoData.coords.longitude};
            if (snappedPointsHistory.length > 1) {
                const lastPoint = snappedPointsHistory[snappedPointsHistory.length - 1];
                if (lastPoint['lat'] !== currentPoint.lat && lastPoint['lng'] !== currentPoint.lng) {
                    snappedPointsHistory.push(currentPoint);
                }
            } else {
                snappedPointsHistory.push(currentPoint);
            }
            LocalStorage.setSnappedPointsHistory(snappedPointsHistory);
            this.drawDraftLengthmark();
        }
    }

    public toggleMapStyle() {
        this.mapTypeId.set(this.mapTypeId() === 'satellite' ? 'roadmap' : 'satellite');
        this.mapStyleRoad = this.mapTypeId() === 'roadmap';
    }

    public setCustomerArea(customerArea: CustomerArea, inspection: Inspection) {
        this.customerArea.set(customerArea);
        this.inspection.set(inspection);
        if (customerArea) {
            this.showSelectionBarDecider(inspection);
            this.subscriptions.add(this.filterComponent.filterEmitter.subscribe(filter => {
                if (filter.deleted) {
                    this.showPriceSelectionBar = false;
                } else {
                    this.showSelectionBarDecider(inspection);
                }
            }));
            setTimeout(() => {
                this.townRegion = new Region(customerArea.area);
                if (!this.initialViewAsParam) {
                    this.centerTown();
                }
            });
            this.manualAreasComponent.customerArea = this.customerArea();
            this.manualAreasComponent.inspection = this.inspection();
            let manualAreas = [];
            if (this.inspection()?.manual_areas) {
                manualAreas = this.inspection()?.manual_areas;
            }
            if (this.customerArea()?.manual_areas) {
                const currentMaIds = manualAreas.map(m => m.id) ?? [];
                manualAreas.push(...this.customerArea()?.manual_areas.filter(m => !currentMaIds.includes(m.id)));
            }
            const manualPolygons = [];
            manualAreas.forEach(area => {
                manualPolygons.push(area);
            });
            this.townRegion = new Region(customerArea.area);
            if (!this.initialViewAsParam) {
                this.centerTown();
            }
            this.manualAreasComponent.customerArea = this.customerArea();
            this.manualAreasComponent.inspection = this.inspection();
            this.manualAreasComponent.areas.set(manualAreas);

            // Remove existing geoJson manual areas before adding new ones
            this.googleMap.data.forEach(feature => {
                this.googleMap.data.remove(feature);
            });

            manualAreas?.filter(m => m.isGeoJson).forEach(area => {
                const features = this.googleMap.data.addGeoJson(area.exteriorRing);
                features.forEach(feature => {
                    this.googleMap.data.overrideStyle(feature, {
                        strokeColor: area.strokeColor || '#FF0000',
                        strokeWeight: area.width || 1,
                        fillColor: area.fillColor || '#FF0000',
                        fillOpacity: 0.4,
                        clickable: false
                    });
                });
            });
            this.showAddPinButton = this.AuthorisationService.hasFeature('pushpinAlwaysAdd') || this.inspection()?.inspection_status.create_allowed;
        } else {
            navigator.geolocation.getCurrentPosition((geolocation) => {
                this.setMapCenter({lat: +geolocation.coords.latitude, lng: +geolocation.coords.longitude});
            });
        }
    }

    public toggleFilter() {
        this.filterComponent.toggleFilter();
    }

    public centerTown() {
        this.mapZoom.set(this.townRegion.bestMapView(window.innerWidth, window.innerHeight, 5));
        this.setMapCenter(this.townRegion.centroid());
    }

    public navigateToPushpin() {
        if (this.inspection()?.lock) {
            this.confirmDialogService.confirm(
                'Schouwronde vergrendeld',
                `Je kunt geen punten toevoegen aan deze schouwronde omdat deze is vergrendeld`,
                'Sluiten',
                null).then(() => {
            }, () => {
            });
        } else if (this.inspection()) {

            const region = new Region(this.customerArea().area);
            let insideTown = region.insideTown(this.mapCenter());

            if (this.customerArea().geojson) {
                const geopolygons = [];
                this.customerArea()?.geojson.features.forEach(feature => {
                    feature.geometry.coordinates.forEach(polygonGroups => {
                        const polygons = polygonGroups.map(polygon =>
                            polygon.map(coord => {
                                return {lat: coord[1], lng: coord[0]};
                            }));
                        geopolygons.push(polygons);
                    });
                });

                insideTown = geopolygons.some(geopolygon => {
                    const outerRing = new Region(geopolygon[0]);

                    if (!outerRing.insideTown(this.mapCenter())) {
                        return false;
                    }

                    return !geopolygon.slice(1).some(hole => new Region(hole).insideTown(this.mapCenter()));
                });
            }

            if (!insideTown) {
                this.confirmDialogService.confirm(
                    'Buiten gebiedsgrens',
                    // tslint:disable-next-line:max-line-length
                    `Weet je zeker dat je een punaise aan wilt maken buiten de gebiedsgrens van ${this.customerArea().kind} ${this.customerArea().name}`,
                    'Ja',
                    'Nee').then(() => {
                    this.createPushpin();
                }, () => {
                });
            } else {
                let manualArea = null;
                this.manualAreasComponent.areas().forEach((area: ManualArea) => {
                    if (area.show_notification && !manualArea) {
                        let manualRegion = new Region(area.exteriorRing);
                        if (area.isStreet) {
                            manualRegion = new Region(area.snappedPoints);
                        }
                        if (manualRegion && manualRegion.insideTown(this.mapCenter())) {
                            manualArea = area;
                        }
                    }
                });

                if (manualArea !== null) {
                    this.confirmDialogService.confirm(
                        'Binnen gemarkeerd gebied',
                        `Weet je zeker dat je een punaise aan wilt maken binnen gebied ${manualArea.name}?`,
                        'Ja',
                        'Nee').then(() => {
                        this.createPushpin();
                    }, () => {
                    });
                } else {
                    this.createPushpin();
                }
            }
        } else {
            this.confirmDialogService.confirm(
                'Selecteer eerst een schouwronde',
                `Selecteer eerst in de prijzenbalk (links) een schouwronde om een punt toe te kunnen voegen.`,
                'Sluiten',
                null).then(() => {

            }, () => {
            });
        }
    }

    centerGps() {
        if (this.gpsLocation && !this.gpsFailure) {
            this.followLocation = true;
            setTimeout(() => {
                this.setMapCenter(this.gpsLocation);
                if (this.mapZoom() < 16) {
                    this.mapZoom.set(16);
                }
                this.cdref.detectChanges();
            });
        } else {
            this.confirmDialogService.confirm(
                'Locatie niet toegestaan',
                'Geef toegang tot je locatie om deze functionaliteit te gebruiken.',
                'Opnieuw proberen',
                'Geen GPS gebruiken').then(() => {
                this.setupGeo();
            }, () => {
            });
        }
    }

    public deleteDraftPushpin() {
        this.routePoints = [];
        LocalStorage.removeSnappedPointsHistory();
        const pushpin = this.pushpins().find(p => p.draft);
        if (pushpin?.end_lat) {
            this.confirmDialogService.confirm(
                'Lengtemarkering corrigeren annuleren',
                `Weet je zeker dat je de correctie van de huidige lengtemarkering wilt annuleren?`,
                'Correctie annuleren',
                'Doorgaan'
            ).then(() => {
                this.router.navigate([
                    'pushpins/map-detail',
                    pushpin.id,
                    this.mapZoom(),
                    pushpin.end_lat,
                    pushpin.end_lng,
                    {inspection: this.inspection()?.id}
                ]);
                this.draftPolyLine = null;
                this.cdref.detectChanges();
            }, () => {

            });
        } else {
            this.confirmDialogService.confirm(
                'Lengtemarkering verwijderen',
                `Weet je zeker dat je de huidige lengtemarkering wilt verwijderen?`,
                'Verwijderen',
                'Annuleren'
            ).then(() => {
                this.pushpinService.deletePushpin(pushpin.id, this.customerArea().id).then((result) => {
                    this.pushpinCreated.emit(true);
                });
                this.draftPolyLine = null;
            }, () => {

            });
        }
    }

    public navigateDraftPushpin() {
        this.routePoints = [];
        this.draftPolyLine = null;
        this.router.navigate([
            'pushpins/map-detail',
            this.pushpins().filter(p => p.draft)[0].id,
            this.mapZoom(),
            this.googleMap.getCenter().lat(),
            this.googleMap.getCenter().lng(),
            {
                inspection: this.inspection()?.id,
                walking: this.travelModeWalking,
                useRoute: this.lengthMarkUseRoute
            }
        ]);
    }

    public reloadPushpins(pushpins: Pushpin[]) {
        if (this.customerArea()) {
            this.pushpins.set(pushpins);
            this.lengthMarkDraft = this.pushpins().find(p => p.draft);
            this.drawDraftLengthmark();
        } else if (Array.isArray(pushpins)) {
            this.pushpins.set(pushpins);
        }
    }

    onMapClick(event: google.maps.MapMouseEvent) {
        this.isSearching = false;
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        this.selectedPushpins.set([]);

        /*
            Calculate ratio between the pushpins on the map, when pushpins are close
            together show a detail preview box with those pushpin details
        */

        const latitudeRanges = {
            22: 0.00002,
            21: 0.00003,
            20: 0.00003,
            19: 0.00005,
            18: 0.00012,
            17: 0.00025,
            16: 0.0006,
            15: 0.0012,
            14: 0.0025,
            13: 0.005,
            12: 0.012,
            11: 0.024,
            10: 0.050,
            9: 0.09
        };
        const longitudeRanges = {
            22: 0.00003,
            21: 0.00004,
            20: 0.00005,
            19: 0.00008,
            18: 0.0002,
            17: 0.0004,
            16: 0.001,
            15: 0.002,
            14: 0.004,
            13: 0.008,
            12: 0.02,
            11: 0.04,
            10: 0.08,
            9: 0.15
        };

        const latitudeRange = latitudeRanges[Math.round(this.mapZoom())];
        const longitudeRange = longitudeRanges[Math.round(this.mapZoom())];
        this.pushpins().forEach((pushpin) => {
            let pushpinInRange = false;
            if (pushpin.lengthmark && pushpin.snappedpoints) {

                if (pushpin.snappedpoints['snappedPoints'] !== 'undefined') {
                    const points = pushpin.snappedpoints['snappedPoints'];

                    points.forEach((point) => {
                        if (!pushpinInRange) {
                            const calculatedLatitudeDifference = +Math.abs(((point.lat ?? point.latitude) - +lat));
                            const calculatedLongitudeDifference = +Math.abs(((point.lng ?? point.longitude) - +lng));

                            if (calculatedLatitudeDifference < latitudeRange && calculatedLongitudeDifference < longitudeRange) {
                                pushpinInRange = true;
                            }
                        }
                    });
                }
            } else {
                const calculatedLatitudeDifference = +Math.abs((+pushpin.lat - +lat));
                const calculatedLongitudeDifference = +Math.abs((+pushpin.lng - +lng));

                if (calculatedLatitudeDifference < latitudeRange
                    && calculatedLongitudeDifference < longitudeRange) {
                    pushpinInRange = true;
                }
            }
            if (pushpinInRange) {
                if (pushpin.pushpin_parts) {
                    pushpin.pushpin_parts.forEach((part) => {
                        part.material = this.getMaterial(part.material_id);
                        part.status = this.getStatus(part.status_id);
                        part.decoration = this.getDecoration(part.decoration_id);
                    });
                }

                pushpin['material_surfaces'] = this.getMaterialSurfaces(pushpin);
                this.selectedPushpins().push(pushpin);
            }
        });

        let top = event['pixel'].y + 10;
        let left = event['pixel'].x + 15;
        let right = 'auto';
        let bottom = 'auto';
        const screenHeight = window.innerHeight;
        const screenWidth = window.innerWidth;
        const isMobile = screenWidth < 768;
        let maxHeight: string;

        if (isMobile) {
            maxHeight = 'calc(100vh - 3rem)';
        } else {
            // On desktop, calculate max height based on position
            const spaceBelow = screenHeight - event['pixel'].y - 20;
            const spaceAbove = event['pixel'].y - 30;

            if (top > screenHeight / 2) {
                bottom = ((event['pixel'].y - screenHeight) * -1) + 20 + 'px';
                top = 'auto';
                maxHeight = Math.max(spaceAbove, 100) + 'px';
            } else {
                top = top + 'px';
                maxHeight = Math.max(spaceBelow, 100) + 'px';
            }
        }

        if (left > (screenWidth - 450)) {
            left = 'auto';
            right = (screenWidth - event['pixel'].x + 5) + 'px';
        } else {
            left = left + 'px';
        }

        this.ngZone.run(() => {
            this.selectedPosition = {
                left: left,
                right: right,
                top: top,
                bottom: bottom,
                maxHeight: maxHeight
            };
        });
    }

    onMapRightClick(event: google.maps.MapMouseEvent) {
        if (this.manualAreasComponent?.manualAreaDrawing()) {
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            const area = this.manualAreasComponent.areas().find(a => a.drawing);
            if (area) {
                if (!area.exteriorRing) {
                    area.exteriorRing = [];
                }
                area.exteriorRing.push({lat, lng});

                if (area.isStreet) {
                    this.manualAreasComponent.drawPolygon(area);
                }
            }
            this.manualAreasComponent.drawingArea.set(area);
            this.manualAreasComponent.drawingArea().exteriorRing = [...this.manualAreasComponent.drawingArea().exteriorRing];
            this.cdref.detectChanges();
        }
        this.addPointToSelection(event);
    }

    private getMaterial(materialId: number) {
        return this.materials.find(p => p.id === materialId);
    }

    private getMaterialSurfaces(pushpin: Pushpin): {
        id, material, surface
    }[] {
        const materials = [];

        if (pushpin.pushpin_parts) {
            pushpin.pushpin_parts.forEach(part => {
                const deco = this.getDecoration(part.decoration_id);
                let material = materials.filter(p => p.id === part.material_id).pop();
                if (!material) {
                    material = {
                        id: part.material_id,
                        material: part.material.name,
                        surface: 0
                    };
                    materials.push(material);
                }
                if (pushpin.lengthmark) {
                    material.surface += part.amount * part.length;
                } else {
                    if (deco?.surface) {
                        if (part.length) {
                            material.surface += part.amount * deco.surface * part.length;
                        } else {
                            material.surface += part.amount * deco.surface;
                        }
                    } else {
                        material.surface += part.amount * part.surface;
                    }
                }
            });
        }

        return materials;
    }

    private getDecoration(decorationId: number) {
        return this.decorations.find(p => p.id === decorationId);
    }

    private getStatus(statusId: number) {
        return this.statuses.find(p => p.id === statusId);
    }

    drawDraftLengthmark() {
        const draftPushPin = this.pushpins().find(p => p.draft);

        if (draftPushPin) {
            const pointList = [];
            if (this.lengthMarkUseRoute) {
                const snappedPointsHistory = LocalStorage.getSnappedPointsHistory();
                if (snappedPointsHistory) {
                    snappedPointsHistory.forEach(point => {
                        pointList.push({lat: point['lat'], lng: point['lng']});
                    });
                }
            } else {

                // When end_lat is filled, we are adding a middle point
                if (draftPushPin.end_lat) {
                    pointList.push({lat: draftPushPin.lat, lng: draftPushPin.lng});
                    pointList.push({lat: +this.googleMap.getCenter().lat(), lng: +this.googleMap.getCenter().lng()});
                    pointList.push({lat: draftPushPin.end_lat, lng: draftPushPin.end_lng});
                }

                pointList.push({lat: draftPushPin.lat, lng: draftPushPin.lng});

                pointList.push({lat: +this.googleMap.getCenter().lat(), lng: +this.googleMap.getCenter().lng()});
            }
            this.subscriptions.add(this.locationService.getSnappedRoute(pointList, this.travelModeWalking).subscribe(result => {
                if (this.pushpins().find(p => p.draft)) {
                    this.draftPolyLine = result.snappedPoints;
                    this.distanceDraftLengthMark.set(result.totalLength);
                    this.routePoints = result?.simplePoints ?? [];
                } else {
                    this.draftPolyLine = null;
                }
            }));
        }
    }

    /**
     * Zet het mapCenter alleen als lat/lng geldig zijn.
     */
    setMapCenter(center: { lat: any, lng: any }) {
        if (
            center &&
            typeof center.lat === 'number' &&
            typeof center.lng === 'number' &&
            isFinite(center.lat) &&
            isFinite(center.lng)
        ) {
            this.mapCenter.set({lat: +center.lat, lng: +center.lng});
        } else {
            console.warn('Ongeldige mapCenter coordinaten:', center);
        }
    }

    addPointToSelection(event) {
        if (this.pushpinMoveComponent?.selectionEnabled) {
            this.selectionPolygon.update(polygon => [...polygon, {
                lat: event?.latLng?.lat(),
                lng: event?.latLng?.lng()
            }]);
            this.pushpinMoveComponent.getIncludedParts();
        }
    }

    removePointFromSelectionPolygon(event, index) {
        this.selectionPolygon.update(polygon => {
            const updated = [...polygon];
            updated.splice(index, 1);
            return updated;
        });
        this.pushpinMoveComponent.getIncludedParts();
    }

    changeDrawingArea(event: google.maps.MapMouseEvent, i: number) {
        this.manualAreasComponent.drawingArea().exteriorRing[i] = {lat: event.latLng.lat(), lng: event.latLng.lng()};
        this.manualAreasComponent.drawingArea().exteriorRing = [...this.manualAreasComponent.drawingArea().exteriorRing];
        this.cdref.detectChanges();
    }

    private lastArea = null;

    onCenterChanged() {
        this.updateUrl();
        let areaFound = false;
        this.manualAreasComponent?.areas()?.forEach((area: ManualArea) => {
            if (area.name) {
                const manualRegion = new Region(area.isStreet ? area.snappedPoints : area.exteriorRing);
                if (manualRegion && manualRegion.insideTown({lat: this.googleMap.getCenter().lat(), lng: this.googleMap.getCenter().lng()})) {
                    areaFound = true;
                    if (this.lastArea !== area.id && this.areaSnackbarRef) {
                        this.areaSnackbarRef.dismiss();
                        this.areaSnackbarRef = null;
                    }
                    if (!this.areaSnackbarRef) {
                        this.areaSnackbarRef = this.matSnackbar.open(area.name, null);
                    }
                    this.lastArea = area.id;
                }
            }
        });
        if (!areaFound) {
            if (this.areaSnackbarRef) {
                this.areaSnackbarRef.dismiss();
            }
            this.lastArea = null;
            this.areaSnackbarRef = null;
        }

        const latDiff = Math.abs(this.googleMap.getCenter().lat() - this.gpsLocation?.lat);
        const longDiff = Math.abs(this.googleMap.getCenter().lng() - this.gpsLocation?.lng);
        if (this.followLocation) {
            if (latDiff > 0.00001 || longDiff > 0.00001) {
                this.followLocation = false;
                console.log('Disabled followLocation because of enough user interaction');
            } else {
                if (this.gpsLocation.lat !== this.googleMap.getCenter().lat() && this.gpsLocation.lng !== this.googleMap.getCenter().lng()) {
                    console.log('Updating center because following GPS location, diff:', latDiff, longDiff);
                    this.setMapCenter(this.gpsLocation);
                }

            }
        }

        this.drawDraftLengthmark();
    }

    changeSelectionPolygon(event, index) {
        this.selectionPolygon.update(polygon => {
            const updated = [...polygon];
            updated[index] = {lat: event?.latLng?.lat(), lng: event?.latLng?.lng()};
            return updated;
        });
        this.cdref.detectChanges();
        this.pushpinMoveComponent.getIncludedParts();
    }

    onZoomChanged() {
        this.updateUrl();
    }

    private initializeMap() {
        this.cordovaService.setBackbuttonAction(() => {
            this.router.navigate(['/customer-selection']);
        });
        this.isCordova = typeof cordova !== 'undefined';
        this.lengthMarkUseRoute = this.isCordova;

        this.subscriptions.add(this.cordovaService.deviceHasInternet.subscribe((hasInternet) => {
            this.deviceHasInternet = hasInternet;
        }));
        this.manualAreasComponent.mapComponent = this;
        this.pushpinMoveComponent.mapComponent = this;

        this.materialService.getMaterials().then(materials => {
            this.materials = materials;
        });
        this.decorationsService.getList().then(decorations => {
            this.decorations = decorations;
        });
        this.statusService.getStatuses().then(statuses => {
            this.statuses = statuses;
        });

        this.subscriptions.add(this.activatedRoute.params.pipe(first()).subscribe(params => {
            if (params['zoom'] && !isNaN(+params['zoom'])) {
                this.mapZoom.set(+params['zoom']);
                this.initialViewAsParam = true;
            }

            if (params['lat'] && params['lng'] && params['lat'] !== 'null') {
                this.setMapCenter({
                    lat: +params['lat'],
                    lng: +params['lng']
                });
            } else {
                if (this.townRegion) {
                    setTimeout(() => {
                        this.setMapCenter(this.townRegion.centroid());
                    }, 1000);
                }
            }
        }));

        this.subscriptions.add(this.activatedRoute.params.subscribe(params => {
            if (params['zoom'] && !isNaN(+params['zoom'])) {
                this.mapZoom.set(+params['zoom']);
            }
            if (!this.customerArea() && params['view'] === 'map' && this.prevView === 'map-detail') {
                this.initialViewAsParam = false;
            }
            if (params['view'] === 'map' && this.prevView !== params['view']) {
                setTimeout(() => {
                    if (this.selectionComponent) {
                        this.selectionComponent.calculatePrices();
                    }
                });
            }
            this.prevView = params['view'];
        }));

        this.subscriptions.add(
            this.filterComponent.filterEmitter.subscribe((filter) => {
                this.filter = filter;
                this.latestUpdatedAt = -1;
                if (this.filter.deleted && this.selectionComponent.selectionVisible()) {
                    this.selectionComponent.toggleSelection();
                }
            })
        );

        let lastRoad = null;
        this.addressSearch = this.addressAutocomplete.valueChanges.pipe(
            // delay emits
            debounceTime(300),
            // use switch map so as to cancel previous subscribed events, before creating new once
            switchMap(value => {
                if (value && typeof value === 'string' && value?.match(/^([an][0-9]+)(([ ,]{1,3})([0-9]{1,4}[,. ]?[0-9]?))?/i)) {
                    return this.locationService.searchHecto(value).pipe(map((result) => {
                        this.hectoPins = result.data;
                        const res = [];
                        let waynumber = null;
                        result.data.forEach(rs => {
                            waynumber = rs.waynumber;
                            const hectometreFormatted = formatNumber(rs.hectometre / 10, 'nl', '1.1-1');
                            const directionOrLetter = (rs.direction || rs.letter || '');
                            res.push({
                                name: `${rs.waynumber}, ${hectometreFormatted} ${directionOrLetter}`,
                                lat: rs.lat,
                                lng: rs.lng
                            });
                        });
                        if (waynumber !== lastRoad) {
                            lastRoad = waynumber;
                            // TODO: Implementeer hecto pins
                        }
                        return res;
                    }));
                } else if (value && value !== '') {
                    // lookup from Bing Location Service
                    const addresses$ = this.locationService.getAddresses(value);
                    const pushPins$ = this.pushpinService.searchPushpins(value, this.customerArea().id, this.inspection()?.id, this.filter);

                    return combineLatest([addresses$, pushPins$]).pipe(
                        map(([addresses, pushpins]) => {
                            const results = [];

                            addresses.resourceSets[0].resources.forEach(rs => {
                                results.push({
                                    name: rs.name,
                                    lat: rs.point.coordinates[0],
                                    lng: rs.point.coordinates[1]
                                });
                            });

                            pushpins.forEach(rs => {
                                results.push({
                                    name: 'Punaise ' + rs.number,
                                    lat: rs.lat,
                                    lng: rs.lng
                                });
                            });

                            return results;
                        }));
                } else {
                    return of(null);
                }
            })
        );
        this.setupGeo();
    }

    private showSelectionBarDecider(inspection: Inspection) {
        this.showPriceSelectionBar = (
                (this.AuthorisationService.hasFeature('priceList') && inspection?.inspection_status_id > 2) ||
                this.AuthorisationService.hasFeature('showPushpinSelectionBarAlways')
            )
            && window.matchMedia('(min-width: 1100px)').matches;
    }

    private updateUrl() {
        if ((this.customerArea() || this.nearby) &&
            this.mapZoom() &&
            this.mapCenter() &&
            this.googleMap.getCenter().lat() &&
            this.view === 'map') {
            this.ngZone.run(() => {
                if (this.googleMap && this.view === 'map' && this.activeRoute.snapshot.params['view'] === 'map') {
                    this.router.navigate([
                        `pushpins`,
                        this.activeRoute.snapshot.params['view'],
                        this.customerArea()?.id ?? 'nearby',
                        this.googleMap.getZoom(),
                        this.googleMap.getCenter().lat(),
                        this.googleMap.getCenter().lng(),
                        {inspection: this.activeRoute.snapshot.params?.inspection}
                    ]);
                }
            });
        }
    }

    private createPushpin() {
        if (this.deviceHasInternet) {
            const pushpin = new Pushpin();
            pushpin.lat = this.googleMap.getCenter().lat();
            pushpin.lng = this.googleMap.getCenter().lng();
            pushpin.customer_area_id = this.customerArea().id;
            pushpin.customer_area = this.customerArea();
            const dialogRef = this.dialog.open(CreatePushpinDialogComponent, {
                panelClass: 'pushpin-dialog',
                data: pushpin
            });
            this.cordovaService.setBackbuttonAction(() => {
                dialogRef.close();
            });
            const subscription = dialogRef.afterClosed().subscribe((_pushpin: Pushpin & string) => {
                if (typeof _pushpin === 'object') {
                    if (_pushpin && (_pushpin as Pushpin).lengthmark) {
                        this.pushpinCreated.emit(true);
                        this.distanceDraftLengthMark.set(0);
                        this.routePoints = [];
                        LocalStorage.removeSnappedPointsHistory();
                        this.routeHistory({coords: {latitude: this.gpsLocation.lat, longitude: this.gpsLocation.lng}}, true);
                    } else if (_pushpin && !(_pushpin as Pushpin).lengthmark) {
                        this.router.navigate([
                            'pushpins/map-detail',
                            (_pushpin as Pushpin).id,
                            this.mapZoom(),
                            this.googleMap.getCenter().lat(),
                            this.googleMap.getCenter().lng(),
                            {inspection: this.inspection().id}
                        ]);
                    }
                } else if (_pushpin === 'extraCost') {
                    this.addExtraCost.emit();
                } else if (_pushpin === 'tailCharge') {
                    this.addTailCharge.emit();
                }
                this.cordovaService.setBackbuttonAction(() => {
                    this.router.navigate(['/']);
                });
                subscription.unsubscribe();
            });
        } else {
            this.confirmDialogService.confirm(
                'Geen Internet',
                'Het apparaat heeft momenteel geen internetverbinding. Er kan geen punaise worden aangemaakt.',
                'Oké',
                null).then(() => {

            }, () => {

            });
        }
    }
}
